export default "__VITE_ASSET__a02f5579__"